// extracted by mini-css-extract-plugin
export var category = "blog-post-preview-module--category--fmapy";
export var date = "blog-post-preview-module--date--GVxYb";
export var excerpt = "blog-post-preview-module--excerpt--6mjmA";
export var inGrid = "blog-post-preview-module--inGrid--nNPL5 blog-post-preview-module--root--IgtTg";
export var inList = "blog-post-preview-module--inList--rmBjN blog-post-preview-module--root--IgtTg";
export var leadMediaThumb = "blog-post-preview-module--leadMediaThumb--zdyaA";
export var root = "blog-post-preview-module--root--IgtTg";
export var text = "blog-post-preview-module--text--7shLQ";
export var title = "blog-post-preview-module--title--WQjvv";